import {useEffect, useState} from "react";
import {Alert, Spinner} from "react-bootstrap";
import Markdown from "react-markdown";
import {useNavigate} from "react-router-dom";

export function RenderMarkdown({path}) {
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)
    const [markdownContent, setMarkdownContent] = useState()

    useEffect(() => {
        fetch(path)
            .then(response => {
                if (response.ok) {
                    return response.text()
                }
                return Promise.reject(`Failed to load ${path} content.`)
            })
            .then(data => {
                console.log(data)
                setMarkdownContent(data)
            })
            .catch(err => setError(err))
            .finally(() => setLoading(false))
    }, [path])

    return <>
        <Alert className="mt-2" variant="danger" show={error} dismissible onClose={() => setError(null)}>{error}</Alert>
        {loading ?
            <div className="mt-2 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
            :
            <Markdown>{markdownContent}</Markdown>
        }
    </>
}

export function RenderMarkdownGitHub({github, routerPath}) {
    const [markdownContent, setMarkdownContent] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(github)
            .then(response => {
                if (!response.ok) throw new Error(`Failed to load ${github}`);
                return response.text();
            })
            .then(setMarkdownContent)
            .catch(setError)
            .finally(() => setLoading(false));
    }, [github]);

    return (
        <>
            {error && <div>Error: {error.message}</div>}
            {loading ? (
                <div>Loading...</div>
            ) : (
                <Markdown
                    components={{
                        a: ({href, children}) => {
                            const isRelative = !href.startsWith("http")

                            if (isRelative && routerPath) {
                                const newHref = href.replace(/^\./gm, "").replace(/^\//gm, "")
                                const route = routerPath.replace(/\/$/gm, "") + "/" + newHref

                                return (
                                    <a
                                        href={route}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(route);
                                        }}
                                        style={{cursor: 'pointer'}}
                                    >
                                        {children}
                                    </a>
                                );
                            }

                            // fallback for external links
                            return (
                                <a href={href} target="_blank" rel="noopener noreferrer">
                                    {children}
                                </a>
                            );
                        },
                    }}
                >
                    {markdownContent}
                </Markdown>
            )}
        </>
    );
}
